import React, { Fragment } from "react";

import { EuiBreadcrumbs, EuiSpacer } from "@elastic/eui";

export default function ManualBreadcrumbs() {
  const breadcrumbs = [
    {
      text: "Overview",
      href: "/en/Outdoor_Cameras/IN-9820_QFHD/",
    },
    {
      text: "Specifications",
      href: "/en/Outdoor_Cameras/IN-9820_QFHD/Technical_Specifications/",
    },
    {
      text: "Features",
      href: "/en/Outdoor_Cameras/IN-9820_QFHD/Product_Features/",
    },
    {
      text: "Installation",
      href: "/en/Outdoor_Cameras/IN-9820_QFHD/Quick_Installation/",
    },
    {
      text: "Lense Adjustment",
      href: "/en/Outdoor_Cameras/IN-9820_QFHD/Lense_Adjustment/",
    },
    {
      text: "Usermanual",
      href: "/en/Outdoor_Cameras/IN-9820_QFHD/Usermanual/",
    },
    {
      text: "◄ Outdoor Cameras",
      href: "/en/Outdoor_Cameras/",
    },
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={10}
        aria-label="INSTAR IN-9820 4K UHD Online Usermanual Chapters"
      />
      <EuiSpacer />
    </Fragment>
  );
}
